import AccessControl_Automations from "./automation/check-automation-rules";
import {CompanyRole} from "../const/company-role";
import AccessControl_Company from "./company/check-company-rules";

module.exports = {

    task: require('./task/check-task-rules'),
    event: require('./event/check-event-rules'),
    project: require('core/gd/access-control/project/check-project-rules'),
    company: new AccessControl_Company(),
    discussion: require('./discussion/check-discussion-rules'),
    automation: new AccessControl_Automations(),

    taskMessage: {
        canEdit(taskMessage, projectId) {
            return gd.ac.check.project.fullAccess(projectId) || taskMessage.fromUserId === gd.session.me.id;
        }
    },

    customField: {

        canEdit(customFieldId) {

            const customField = gd.session.customFields.get(customFieldId);

            if (!customField) return false;

            return (gd.ac.check.company.isManager(customField.companyId));
        }
    },

    isGuest(companyId) {
        const companyUser = gd.session.companyUsers.findByCompanyAndUser(companyId, gd.session.me.id);
        return (companyUser && companyUser.companyRole===gd.const.companyRole.GUEST);
    },

    canShareView() {
        if (!gd.modules.publicSharing.enabled) return false

        return gd.ac.check.company.isUser(gd.companyId);
    },

    createRootProject() {

        switch (gd.company.role) {
            case CompanyRole.MANAGER:
                return true
            case CompanyRole.USER:
                return gd.company.settings.companyRole.user.createRootProject
            default:
                return false
        }

        // return gd.ac.check.company.isManager(gd.companyId)
    },

    createAutomation() {

        const isManager         = gd.ac.check.company.isManager(gd.companyId)
        const isFullAccessInAnyProject = _.some(gd.session.projectUsers.models, (model)=>{

            // patch
            if (!model.user) return false

            return model.user.id === gd.user.id && model.access >= gd.const.project.access.FULL
        })

        // console.log("Check Rules createAutomation", isManager, isFullAccessInAnyProject, gd.session.projectUsers.filterByUser(gd.user.id, gd.const.project.access.FULL));

        return isManager || isFullAccessInAnyProject;
    },

    canAddCompanyUsers(companyId) {
        let res = false;
        if (companyId){

            const companyUser = gd.session.companyUsers.findByCompanyAndUser(companyId, gd.session.me.id);

            if (companyUser && companyUser.companyRole === gd.const.companyRole.MANAGER ) {
                res = true;
            }
        }

        return res;
    },

    canCreateProject(companyId=null) {
        let res = false;
        if (gd.companyId){
            const companyUser = gd.session.companyUsers.findByCompanyAndUser(companyId, gd.session.me.id);

            if (companyUser &&
                [
                    gd.const.companyRole.MANAGER,
                    gd.const.companyRole.USER
                ].indexOf(companyUser.companyRole) !== -1 ) { res = true; }
        }
        return res;
    },

    dashboardAllTilesAllowedRoles() {
        return [gd.const.companyRole.USER, gd.const.companyRole.MANAGER];
    },

    showNewProjectBtn() {
        return (gd.session.companies.filterByRoles([gd.const.companyRole.MANAGER,gd.const.companyRole.USER]).length>0)
    },

    showNewCompanyEventBtn() {
        return (gd.session.companies.filterByRoles([gd.const.companyRole.MANAGER,gd.const.companyRole.USER]).length>0)
    },

    showNewUserBtn() {
        let res = false;
        gd.session.companies.map(function(company){
            if (company.role>=4) res = true;
        });
        return res;
    },

    companyUsersViewAllowedRoles() {
        return [gd.const.companyRole.USER, gd.const.companyRole.MANAGER];
    },

    projectManagerCompanyAllowedRoles() {
        return [gd.const.companyRole.USER, gd.const.companyRole.MANAGER];
    },

    isOrganizationAdmin(companyId=null) {

        if (!companyId) companyId = gd.companyId

        let res = false;
        if (companyId){
            const companyUser = gd.session.companyUsers.findByCompanyAndUser(companyId,gd.session.me.id);
            res = companyUser && companyUser.isAdmin;
        }
        return res;
    },

    userIntegrationsEnabled() {
        let res = false;
        gd.session.companies.map(m=>{
            if (m.isPremium) res = true;
        });
        return res;
    },

    canCreateCustomFields(projectId, options) {
        let res = false;
        if (projectId){
            let companyId;
            if (options) {
                companyId = options.companyId;
            } else {
                let project = gd.session.projects.get(projectId);
                companyId = project.companyId
            }

            let organizationRole = gd.session.companies.get(companyId).role;

            res = organizationRole >= gd.const.companyRole.MANAGER;
        }

        return res;
    },
};
